import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { app } from '../firebase';

const functions = getFunctions(app, 'europe-west1');

if (process.env.NODE_ENV === 'development') {
  try {
    connectFunctionsEmulator(functions, 'localhost', 5001);
  } catch {
    // Already connected
  }
}

class SageAuth {
  constructor() {
    this.getConfigFunction = httpsCallable(functions, 'getSageOAuthConfig');
    this.exchangeCodeFunction = httpsCallable(functions, 'exchangeSageCode');
    this.getStatusFunction = httpsCallable(functions, 'getSageStatus');
    this.verifyFunction = httpsCallable(functions, 'verifySageConnection');
    this.refreshTokenFunction = httpsCallable(functions, 'refreshSageToken');
  }

  generateSecureState() {
    if (typeof window !== 'undefined' && window.crypto?.getRandomValues) {
      const array = new Uint32Array(4);
      window.crypto.getRandomValues(array);
      return Array.from(array, (dec) => dec.toString(36)).join('');
    }
    return Math.random().toString(36).slice(2, 15) + Math.random().toString(36).slice(2, 15) + Date.now().toString(36);
  }

  async getAuthorizationUrl(state = null) {
    const configResult = await this.getConfigFunction();
    const config = configResult.data || {};
    const clientId = config.clientId || '';
    const redirectUri = config.redirectUri
      || (typeof window !== 'undefined' ? `${window.location.origin}/sage/callback` : 'https://app.svenry.com/sage/callback');
    const scope = config.scope || 'full_access';
    const authorizeUrl = config.authorizeUrl || 'https://www.sageone.com/oauth2/auth/central';
    const filter = config.filter || 'apiv3.1';

    if (!clientId) {
      throw new Error('Sage Client ID not configured. Add SAGE_CLIENT_ID to Secret Manager.');
    }

    const stateValue = state || this.generateSecureState();
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.setItem('sage_oauth_state', stateValue);
      sessionStorage.setItem('sage_oauth_redirect_uri', redirectUri);
    }

    const params = new URLSearchParams({
      response_type: 'code',
      client_id: clientId,
      redirect_uri: redirectUri,
      scope,
      state: stateValue,
      filter,
    });

    return `${authorizeUrl}?${params.toString()}`;
  }

  async exchangeCodeForToken(code, state, country) {
    const redirectUri = (typeof window !== 'undefined' && window.sessionStorage)
      ? sessionStorage.getItem('sage_oauth_redirect_uri')
      : null;
    const result = await this.exchangeCodeFunction({
      code,
      redirectUri: redirectUri || undefined,
      state,
      country: country || undefined,
    });
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.removeItem('sage_oauth_redirect_uri');
    }
    return result.data;
  }

  async getConnectionStatus() {
    const result = await this.getStatusFunction();
    return result.data;
  }

  async verifyConnection() {
    const result = await this.verifyFunction();
    return result.data;
  }

  async refreshAccessToken() {
    const result = await this.refreshTokenFunction();
    return result.data;
  }

  async connect() {
    const state = this.generateSecureState();
    window.location.href = await this.getAuthorizationUrl(state);
  }
}

const sageAuth = new SageAuth();
export default sageAuth;
